
<app-dialogs [title]="data.title" [msg]="data.msg"></app-dialogs>
<div class="text-right">
  <button mat-raised-button color="primary" [mat-dialog-close]="true">OK</button>
</div>
